import React, { useEffect, useState } from "react";

// components
import SearchTablePageLayout from "../../../components/alcohol/layout/searchTablePage/SearchTablePageLayout";
import CommonModal from "../../../components/modal/CommonModal";
import { getPushMessageFromAlcohol, postPushMessageToAlcohol } from "../../../services/apis/alcohol/message";

// utils
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG, sanitizeText } from "../../../utils/sanitize";


const pageInfo = {
	title: '단체 메시지',
	search: {
		inputPlaceholder: `보낸 사람, 기관명, 부서명, 내용`
	},
	list: {
		title: '메시지 리스트',
		selectOptionList: [],
		tableHeader: ['보낸 사람','기관명','부서명','발송 대상자','성별', '교육', '내용', '발송일자'],
	},
	convert: {
		target : {
			T : "타겟팅",
			A : "전체 사용자"
		},
		training : {
			10: "시작 전",
			20: "정상",
			30: "종료",
			40: "미달",
			45: "탈락"
		},
		sex : {
			A : "전체",
			M : "남",
			F : "여"
		}
	},
	convertKorToEng: {
		target: {
			"타겟팅" : "T",
			"전체 사용자" : "A"
		},
		training: {
			"시작 전" : 10,
			정상: 20,
			종료: 30,
			미달: 40,
			탈락: 45
		}
	}
}


function AlcoholNotificationList() {
	const [pushMessageData, setPushMessageData] = useState([]);
	const [totalDataCnt, setTotalDataCnt] = useState(0);

	const [selectedPage, setSelectedPage] = useState(1);

	const [inputSearchOption, setInputSearchOption] = useState({
		search: "",
		// 타겟팅 여부 -> T(타겟팅) / A(전체 사용자)
		target: "",
		// 성별 -> M / F
		sex: "",
		// 교육 -> 10(시작 전), 20(정상), 30(미달), 40(정상)
		training: ""
	})
	const [searchOption, setSearchOption] = useState({
		search: "",
		target: "",
		sex: "",
		training: ""
	});

	// 특정 메시지 클릭 시 나타나는 팝업 정보
	const [clickedMeassageInfo, setClickedMessageInfo] = useState({
		"발송 대상자": "",
		성별: "",
		교육: "",
		내용: ""
	})
	const [showClickedMessageModal, setShowClickedMessageModal] = useState(false);


	async function getPushMessageFromAPI() {
		try{
			const request = {
				text: searchOption.search,
				target: searchOption.target,
				sex: searchOption.sex === 'A' ? '' : searchOption.sex,
				training: searchOption.training,
				page: selectedPage
			};
			const res = await getPushMessageFromAlcohol(request);
			if(parseInt(res.status/200,10)===1){

				const convert = {
                    training : {
                        10: "시작 전",
                        20: "정상",
                        30: "종료",
                        40: "미달",
                        45: "탈락"
                    }
                }

				if(res.data.length>0){
					const newPushMessageList = res.data.map(e=>({
						'보낸 사람': e.stffName || "",
						기관명: e.instName || "",
						부서명: e.department || "",
						'발송 대상자': e.target ? pageInfo.convert.target[e.target] : "",
						성별: e.sex ? pageInfo.convert.sex[e.sex] : "전체",
						교육: e.training ? e.training.split("|").map(el=>convert.training[el]).join("/") : "전체",
						내용: e.contents || "",
						발송일자: e.insDate ? e.insDate.split('T')[0] : ""
					}))
					setPushMessageData(newPushMessageList);
					setTotalDataCnt(res.data[0].totalCnt);
				}else{
					setPushMessageData([]);
					setTotalDataCnt(0);
				}
			}
		}catch(err){
			console.error(err);
		}
	}

	// 메시지 전송 Modal
	const [showRegisterNotificationModal, setShowRegisterNotificationModal] = useState(false);
	const [input,setInput] = useState({
		target: "",
		sex: "",
		training: "",
		message: ""
	});

	// 메시지 전송 성공 Modal
	const [showSuccessSendModal, setShowSuccessSendModal] = useState(false);


	// 검색 조건
	const resetSearchOption = () => {
		setInputSearchOption({
			search: "",
			target: "",
			sex: "",
			training: ""
		})
	}

	const applySearchOption = () => {
		setSearchOption(inputSearchOption);
	}

	// 메시지 전송 성공 Modal
	const closeSuccessSendModal = () => {
		setShowSuccessSendModal(false);
	}

	const SuccessSendModalBody = <div className="modalbody">메시지를 성공적으로 전송하였습니다.</div>;

	const SuccessSendModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={closeSuccessSendModal}
				style={{ width: '100%' }}
			>
				확인
			</button>
		</div>
	);

	// 메시지 전송 Modal
	const closeRegisterNotificationModal = () => {
		setShowRegisterNotificationModal(false);
		setInput({
			target: "",
			sex: "",
			training: "",
			message: ""
		});
	}

	function getCurrentDateTime() {
        const now = new Date();
        
        // 년, 월, 일, 시, 분을 가져오기
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        // YYYYMMDDHH24MI 형식으로 조합하여 반환
        return `${year}${month}${day}${hours}${minutes}`;
    }

	async function registerNewNotification() {
		if(hasForbiddenChars(input.message)) return;
		if(!input.target || (input.target==="T" && Object.values(input).some(e=>e==="")) || (input.target==="A" && !input.message)){
			alert("모든 값을 입력해주세요.");
			return;
		}

		try{
            const currentDateStr = getCurrentDateTime();

			const request = {
				target: input.target,
				sex: input.sex,
				training: input.training,
				subject: "",
				contents: sanitizeText(input.message),
				sendDate: currentDateStr
			};

			const res = await postPushMessageToAlcohol(request);
			if(parseInt(res.status/200,10)===1){
				setShowSuccessSendModal(true);
				closeRegisterNotificationModal();
				getPushMessageFromAPI();
			}else{
				alert("메시지 전송에 실패하였습니다.");
			}			
		}catch(err){
			console.error(err);
			
		}
	}

	function handleCheckInputTraining(selectedTraining) {
		if(input.training){
			const curTrainingList = input.training.split("|");
			if(curTrainingList.includes(selectedTraining)){
				setInput({
					...input,
					training: curTrainingList.filter(e=>e!==selectedTraining).join("|")
				})
			}else{
				setInput({
					...input,
					training: [...curTrainingList,selectedTraining].sort((a,b)=>Number(a)-Number(b)).join("|")
				})
			}		
		}else{
			setInput({
				...input,
				training: selectedTraining
			})
		}		
	}

	// 메시지 전송 모달
	const RegisterNotificationModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">받는 사람</div>
				<div
					className="formModalItem__input"
					style={{width: '21.875rem', justifyContent: 'space-between'}}
				>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-all"
							type="radio"
							onChange={()=>setInput({
								...input,
								target: pageInfo.convertKorToEng.target["전체 사용자"],
								sex: "",
								training: ""
							})}
							checked={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-all">전체 사용자</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-targeting"
							type="radio"
							onChange={()=>setInput({
								...input,
								target: pageInfo.convertKorToEng.target.타겟팅
							})}
							checked={input.target===pageInfo.convertKorToEng.target.타겟팅}
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-targeting">타겟팅</label>
					</div>					
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">타겟 조건</div>
				<div>
					<div className="formModalItem__subItem" style={{ marginBottom: '1rem' }}>
						<div className="formModalItem__label">성별</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-male"
									type="radio"
									onChange={()=>setInput({
										...input,
										sex: "M"
									})}
									checked={input.sex==="M"}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-male">남</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-female"
									type="radio"
									onChange={()=>setInput({
										...input,
										sex: "F"
									})}
									checked={input.sex==="F"}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-female">여</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-all"
									type="radio"
									onChange={()=>setInput({
										...input,
										sex: "A"
									})}
									checked={input.sex==="A" || input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-all">전체</label>
							</div>					
						</div>
					</div>
					<div className="formModalItem__subItem">
						<div className="formModalItem__label">교육 <span>(중복체크 가능)</span></div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-10"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("10")}
									checked={input.training.split("|").includes("10")}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-10">시작 전</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-20"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("20")}
									checked={input.training.split("|").includes("20")}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-20">정상</label>
							</div>		
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width" />			
						</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-40"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("40")}
									checked={input.training.split("|").includes("40")}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-40">미달</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-45"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("45")}
									checked={input.training.split("|").includes("45")}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-45">탈락</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-30"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("30")}
									checked={input.training.split("|").includes("30")}
									disabled={input.target===pageInfo.convertKorToEng.target["전체 사용자"]}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-30">종료</label>
							</div>					
						</div>
					</div>
				</div>				
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">메시지</div>
				<div className="formModalItem__input">
					<textarea
						type="text"
  						maxLength={300}
						className="formModalItem__input__textarea"
						placeholder="메시지 내용을 입력해주세요. (최대 300자)"
						value={input.message}
						onChange={e => setInput({
							...input,
							message: e.target.value
						})}
						style={{ height: '12.5rem' }}
					/>
					{hasForbiddenChars(input.message) && (
						<div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
							{FORBIDDEN_CHARS_MSG}
						</div>
					)}
				</div>
			</div>
			<div style={{textAlign: 'right', marginRight:"3rem", fontSize: '0.8rem', color: '#888'}}>
				{input.message.length} / 300</div>
		</div>
	);

	const handleCheckSubmitDisabled = () => {
		if(input.target===pageInfo.convertKorToEng.target.타겟팅){
			return Object.values(input).some(e=>e==="");
		}else{
			return !(input.target && input.message);
		}
	}

	const RegisterNotificationModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={registerNewNotification}
				disabled={handleCheckSubmitDisabled()}
			>
				저장
			</button>
			<button className="cancelButton__rounded" onClick={closeRegisterNotificationModal}>
				취소
			</button>
		</div>
	);

	// 메시지 상세 보기 모달
	const closeClickedMessageModal = () => {
		setShowClickedMessageModal(false);
	}

	const ClickedMessageModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">받는 사람</div>
				<div
					className="formModalItem__input"
					style={{width: '21.875rem', justifyContent: 'space-between'}}
				>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-all"
							type="radio"
							checked={clickedMeassageInfo["발송 대상자"]==="전체 사용자"}
							readOnly
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-all">전체 사용자</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-targeting"
							type="radio"
							checked={clickedMeassageInfo["발송 대상자"]==="타겟팅"}
							readOnly
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-targeting">타겟팅</label>
					</div>					
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">타겟 조건</div>
				<div>
					<div className="formModalItem__subItem" style={{ marginBottom: '1rem' }}>
						<div className="formModalItem__label">성별</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-male"
									type="radio"
									checked={clickedMeassageInfo.성별==="남"}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-male">남</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-female"
									type="radio"
									checked={clickedMeassageInfo.성별==="여"}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-female">여</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-all"
									type="radio"
									checked={clickedMeassageInfo.성별==="전체" && clickedMeassageInfo["발송 대상자"]==="전체 사용자"}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-all">전체</label>
							</div>					
						</div>
					</div>
					<div className="formModalItem__subItem">
						<div className="formModalItem__label">교육</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-10"
									type="checkbox"
									checked={clickedMeassageInfo.교육 && clickedMeassageInfo.교육.includes("시작 전")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-10">시작 전</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-20"
									type="checkbox"
									checked={clickedMeassageInfo.교육 && clickedMeassageInfo.교육.includes("정상")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-20">정상</label>
							</div>					
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width" />
						</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-40"
									type="checkbox"
									checked={clickedMeassageInfo.교육 && clickedMeassageInfo.교육.includes("미달")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-40">미달</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-45"
									type="checkbox"
									checked={clickedMeassageInfo.교육 && clickedMeassageInfo.교육.includes("탈락")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-45">탈락</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-30"
									type="checkbox"
									checked={clickedMeassageInfo.교육 && clickedMeassageInfo.교육.includes("종료")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-30">종료</label>
							</div>					
						</div>
					</div>
				</div>				
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">메시지</div>
				<div className="formModalItem__input">
					<textarea
						type="text"
						className="formModalItem__input__textarea"
						value={clickedMeassageInfo.내용}
						style={{ height: '12.5rem' }}
						readOnly
					/>
				</div>
			</div>
		</div>
	);

	// pagination
	const getNewTableDataByPagination = (page) => {
		setSelectedPage(page);
	}

	const handleClickMessageItem = (e) => {
		setClickedMessageInfo(e);
		setShowClickedMessageModal(true);
	}


	useEffect(()=>{
		setSelectedPage(1);
	},[])

	useEffect(()=>{
		getPushMessageFromAPI();
	},[selectedPage])

	useEffect(()=>{
		getPushMessageFromAPI();
	},[searchOption])

    return (
        <div>
        	<SearchTablePageLayout
				type="notification"
				pageInfo={pageInfo}

				tableBody={pushMessageData}
				totalCnt={totalDataCnt}

				tablePageCnt={Math.ceil(totalDataCnt/10)}
				
				setShowRegisterModal={setShowRegisterNotificationModal}

				selectedPage={selectedPage}
				setSelectedPage={setSelectedPage}
				getNewTableDataByPagination={getNewTableDataByPagination}
				
				searchOption={inputSearchOption}
				setSearchOption={setInputSearchOption}
				resetSearchOption={resetSearchOption}
				applySearchOption={applySearchOption}

				clickEvent={handleClickMessageItem}
			/>
			{/* 메시지 전송 modal */}
			<CommonModal
				header="메시지 보내기"
				body={RegisterNotificationModalBody}
				footer={RegisterNotificationModalFooter}
				show={showRegisterNotificationModal}
				setClose={closeRegisterNotificationModal}
				size="lg"
			/>
			{/* 메시지 상세 보기 modal */}
			<CommonModal
				header="메시지"
				body={ClickedMessageModalBody}
				show={showClickedMessageModal}
				setClose={closeClickedMessageModal}
				size="lg"
			/>
			{/* 메시지 전송 성공 modal */}
			<CommonModal
				header="메시지 보내기"
				body={SuccessSendModalBody}
				footer={SuccessSendModalFooter}
				show={showSuccessSendModal}
				setClose={closeSuccessSendModal}
				size="sm"
			/>
		</div>
    );
}

export default AlcoholNotificationList;